// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportFooter.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Footer
 */
!(function() {
  var React = require('react');
  var ReportFormatElement = require('./Izenda.ReportFormatElement');
  var CONSTANTS = require('logic/data/Izenda.ReportDesignerFormatsConstants');
  var connect = require('share/enhancers/Izenda.Connect');
  var classnames = require('classnames');
  var { isEmpty, omit } = require('lodash/fp');

  var ReportFooter = React.createClass({
    publishFinishedRender: function() {
      var props = this.props;
      props.finishedRender && props.finishedRender();
    },
    componentDidUpdate: function() {
      this.props.printingMode && this.publishFinishedRender();
    },
    render: function() {
      var props = this.props;
      var store = props.store;
      var footerElement = store.reportFooter;
      var masterModel = store.masterModel || {};
      var reportFormats = masterModel.reportFormats || {};
      var headerFooter = reportFormats.headerFooter || {};
      var localization = props.localization;
      var className = classnames('report-format-footer', props.className);

      return props.viewMode && (isEmpty(footerElement.formatItems) || !headerFooter.visible) ? null : (
        <ReportFormatElement
          store={store}
          className={className}
          title={localization.getText('REPORTDESIGNER_TOOLTIP_REPORT_FOOTER')}
          formatElement={footerElement}
          cols={CONSTANTS.NUMBER_FOOTER_COLS}
          rows={CONSTANTS.NUMBER_FOOTER_ROWS}
          viewMode={props.viewMode}
          style={props.style}
          {...omit(['className'], props)}
          setting={props.setting}
          horizontalAlign={props.horizontalAlign}
          fillWidth={props.printingMode}
        />
      );
    }
  });

  module.exports = connect()(ReportFooter);
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/Izenda.ReportFooter.jsx